import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocalize } from "../i18n";

const IndexLegend = ({ legends, unit }) => {
  const { t } = useTranslation();
  const localize = useLocalize();
  if (!legends || legends.length === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          fontWeight: 800,
          color: "primary.dark",
          mb: 0.5,
          borderBottom: "1px solid rgba(0,0,0,0.1)",
          pb: 0.5,
          textTransform: "uppercase",
        }}
      >
        {t("map.legend")} {unit ? `(${unit})` : ""}
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
        {legends.map((item, index) => (
          <Box
            key={index}
            sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
          >
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: "3px",
                backgroundColor: item.color,
                boxShadow: "0 0 0 1px rgba(0,0,0,0.1)",
              }}
            />
            <Typography
              variant="body2"
              sx={{ fontSize: "12px", fontWeight: 600, color: "text.primary" }}
            >
              {localize(item, "label")}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default IndexLegend;
